"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/rac/button";
import { getOtpMethodDisplayName, type OtpMethod } from "@/info/login";
import { MessageCircle, MessageSquare } from "lucide-react";
interface OtpMethodSelectorProps {
  selectedMethod: OtpMethod;
  onMethodChange: (method: OtpMethod) => void;
  isDisabled?: boolean;
  countryCode?: string;
}
export function OtpMethodSelector(t0) {
  const $ = _c(17);
  const {
    selectedMethod,
    onMethodChange,
    isDisabled: t1,
    countryCode: t2
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const countryCode = t2 === undefined ? "IN" : t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== countryCode || $[1] !== isDisabled || $[2] !== onMethodChange || $[3] !== selectedMethod) {
    const methods = ["sms", "whatsapp"];
    t5 = "space-y-2 mb-4";
    const t7 = countryCode !== "IN" ? "Send OTP via WhatsApp (SMS not available for international users):" : "Send OTP via:";
    if ($[8] !== t7) {
      t6 = <label className="text-sm font-medium text-gray-700">{t7}</label>;
      $[8] = t7;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t3 = "flex gap-2";
    t4 = methods.map(method => {
      const isSelected = selectedMethod === method;
      const displayName = getOtpMethodDisplayName(method);
      const Icon = method === "whatsapp" ? MessageCircle : MessageSquare;
      return <Button key={method} className="flex-1 h-12 px-4 border transition-all duration-200 touch-manipulation" onPress={() => onMethodChange(method)} isDisabled={isDisabled || method === "sms" && countryCode !== "IN"} variant={isSelected ? "accent" : "ghost"}><div className="flex items-center gap-2"><Icon className="w-4 h-4" /><span className="text-sm font-medium">{displayName}</span></div></Button>;
    });
    $[0] = countryCode;
    $[1] = isDisabled;
    $[2] = onMethodChange;
    $[3] = selectedMethod;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[10] !== t3 || $[11] !== t4) {
    t7 = <div className={t3}>{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5 || $[14] !== t6 || $[15] !== t7) {
    t8 = <div className={t5}>{t6}{t7}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}